export default class Delta {
  constructor() {
    this.delta = 0
    this.dlt = performance.now()
  }

  update() {
    const now = performance.now()
    this.delta = (now - this.dlt) / (1000 / 60)
    this.dlt = now
  }

  getDelta(update = false) {
    if (update) this.update()
    return this.delta
  }
}
